document.addEventListener('DOMContentLoaded',function(){
  var hero=document.querySelector('.btf-cinematic-hero');
  var crew=document.querySelector('.crew-band');
  if(hero&&crew&&!hero.contains(crew)){hero.appendChild(crew);}

  var header=document.querySelector('.btf-nav');
  if(!header){return;}

  var current=window.location.pathname;
  var items=[
    ['/','HOME'],
    ['/pages/our-story','OUR STORY'],
    ['/pages/conservation','CONSERVATION'],
    ['/pages/community','COMMUNITY'],
    ['/pages/events','EVENTS'],
    ['/collections/all','SHOP OUR COLLECTION'],
    ['/pages/contact','CONTACT']
  ];
  var existingLogo=header.querySelector('.btf-logo');
  var logoSrc=existingLogo?existingLogo.getAttribute('src'):'';
  logoSrc=logoSrc.replace(/btf-(?:master-logo|nav-logo-dark|nav-water-splash)\.png[^?]*/,'btf-master-logo.png');
  var nav=items.map(function(item){
    var active=item[0]==='/'?current==='/':current.indexOf(item[0].replace('/all',''))===0;
    return '<a href="'+item[0]+'"'+(active?' class="active" aria-current="page"':'')+'>'+item[1]+'</a>';
  }).join('');
  header.innerHTML='<a class="btf-logo-link" href="/" aria-label="Below The Flag home"><img src="'+logoSrc+'" class="btf-logo" alt="Below The Flag"></a><nav class="btf-main-nav" aria-label="Main navigation">'+nav+'</nav><div class="icons"><a class="fb-nav-link" href="https://www.facebook.com/belowtheflag" target="_blank" rel="noopener noreferrer" aria-label="Below The Flag on Facebook"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 8h3V4h-3c-3.3 0-5 2-5 5v2H6v4h3v7h4v-7h3.5l.5-4h-4V9c0-.7.3-1 1-1z"></path></svg></a><a class="instagram-nav-link" href="https://www.instagram.com/belowtheflag/" target="_blank" rel="noopener noreferrer" aria-label="Below The Flag on Instagram"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm10.5 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"></path></svg></a></div>';
  var finalLogo=header.querySelector('.btf-logo');
  finalLogo.style.setProperty('content','normal','important');

  var footer=document.querySelector('.btf-page>footer');
  if(footer){
    var flagSrc=logoSrc.replace(/btf-(?:master-logo|nav-water-splash|nav-logo-dark)\.png.*$/,'btf-us-flag-flat.svg');
    footer.innerHTML='<div class="btf-veteran-mark"><img class="btf-veteran-flag" src="'+flagSrc+'" alt="Black and white American flag" width="82" height="43"><span>Veteran Owned</span></div><nav class="btf-footer-links" aria-label="Footer navigation"><a href="/collections/all">Shop</a><a href="/pages/conservation">Conservation</a><a href="/pages/journal">Journal</a><a href="/pages/contact">Contact</a><a href="/policies/privacy-policy">Privacy</a></nav><div class="btf-footer-copy">© 2026 Below The Flag™</div>';
  }
});
